import React, { FunctionComponent } from "react";
import styled from "@emotion/styled";
import { sanitiseForDOMToken } from "@iventis/utilities";
import { HyperlinkCellParams } from "../types/data-table.types";
import { TextCellContents } from "./text-cell-renderer";

export const HyperlinkCellRenderer: FunctionComponent<HyperlinkCellParams> = (params) => (
    <TextCellContents valid>
        <StyledHyperLink
            data-testid={sanitiseForDOMToken(`${params.data.name}-hyperlink`)}
            ref={(ref) => {
                if (!ref) return;
                // eslint-disable-next-line no-param-reassign
                ref.onclick = (e) => {
                    e.stopPropagation(); // ref is required in order to stop Ag Grid React synthetic event.
                    params?.onClick(params.column.getColId(), params.data);
                };
            }}
        >
            {params.value}
        </StyledHyperLink>
    </TextCellContents>
);

const StyledHyperLink = styled.span`
    color: ${(props) => props.theme.primaryColors.subdued50};
    text-decoration: underline;
    &:hover {
        color: ${(props) => props.theme.primaryColors.altFocusText};
        cursor: pointer;
    }
`;
